import { PropsWithChildren } from 'react';

export type CardHeaderProps = PropsWithChildren<{
    light?: boolean;
}>;

const Card = ({ children }: PropsWithChildren) => {
    return <div className="bg-white text-neutral-500 rounded-lg relative">{children}</div>;
};

const CardHeader = ({ light, children }: CardHeaderProps) => {
    return <div className={`${!light && 'bg-green-700 text-white'} px-4 md:px-8 py-4 text-left`}>{children}</div>;
};

const CardBody = ({ children }: PropsWithChildren) => {
    return <div className="p-4 py-6 md:p-8 md:py-8">{children}</div>;
};

const CardFooter = ({ children }: PropsWithChildren) => {
    return <div className="border-t border-t-neutral-200 px-4 md:px-8 py-4">{children}</div>;
};

export { Card, CardHeader, CardBody, CardFooter };
